/**
 * Esta funcion determina si la pagina a visitar por el usuario
 * no se encuentra dentro de las denegadas
 */
export const userHaveAccessToPage = (userObject, pageTo) => {
    const denyPages = Array.isArray(userObject.permisos?.denypages) ? userObject.permisos?.denypages : [];
    return !denyPages.includes(pageTo)
}